<template>
  <!-- 年度目标详情 -->
  <div class="year-goal-detail">
    <!-- 已引进医生统计 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>已引进医生</span>
      </div>
      <div class="introduce-stats">
        <div class="stat-item total">
          <div class="stat-num">{{ starInfo.completeTotal || 0 }}</div>
          <div class="stat-label">共引进</div>
        </div>
        <div class="stat-item">
          <div class="stat-num">{{ starInfo['3'] || 0 }}</div>
          <div class="stat-label">3星医生</div>
        </div>
        <div class="stat-item">
          <div class="stat-num">{{ starInfo['4'] || 0 }}</div>
          <div class="stat-label">4星医生</div>
        </div>
        <div class="stat-item">
          <div class="stat-num">{{ starInfo['5'] || 0 }}</div>
          <div class="stat-label">5星医生</div>
        </div>
      </div>
      <!-- <div class="introduce-desc">
        已引入{{ starInfo.completeTotal || 0 }}名，差距{{ starInfo.gap || 0 }}
      </div> -->
    </div>

    <!-- 全年目标 -->
    <div
      v-for="(year, yIdx) in yearGoalList"
      :key="'year-' + yIdx"
      class="section"
      v-show="year.targetStartInfoList && year.targetStartInfoList.length > 0"
    >
      <div class="section-title">
        <span class="title-bar"></span>
        <span>全年目标</span>
      </div>
      <div class="goal-grid">
        <div class="goal-card year-goal-card" v-for="(goal, gIdx) in (year.targetStartInfoList || [])" :key="getGoalKey(goal, gIdx)">
          <div class="goal-card-header">
            <div class="goal-tag year">年度</div>
            <div class="goal-name">{{ goal.saleStar + '星医生' + goal.targetNumber + '名' }}</div>
            <div class="goal-value">
              <span class="current">{{ goal.finishTargetNumber }}</span>
              <span class="total">/{{ goal.targetNumber || 0 }}</span>
            </div>
            <div class="goal-status">
              <span v-if="goal.completeStatus === 1" class="status-undo">
                <i class="el-icon-success"></i>未完成
              </span>
              <span v-if="goal.completeStatus === 2" class="status-done">
                <i class="el-icon-success"></i>完成
              </span>
              <span v-else-if="goal.completeStatus === 3" class="status-done">
                <i class="el-icon-success"></i>超额完成
              </span>
            </div>
          </div>
          <div v-if="showStaffList" class="goal-card-body">
            <span v-for="(team, tIdx) in goal.targetGroupInfoList" :key="team.groupName + '-' + tIdx" class="team-progress">
              {{ team.groupName }} {{ team.finishTargetNumber || 0 }}/{{ team.targetNumber || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 季度目标列表 -->
    <div
      v-for="(quarter, qIdx) in quarterGoalList"
      :key="'quarter-' + quarter.quarter"
      class="section"
      v-show="quarter.goals && quarter.goals.length > 0"
    >
      <div class="section-title">
        <span class="title-bar"></span>
        <span>{{ quarter.name }}</span>
      </div>
      <div class="goal-grid">
        <div class="goal-card" v-for="(goal, gIdx) in quarter.goals" :key="getGoalKey(goal, gIdx)">
          <div class="goal-card-header">
            <div class="goal-tag" :class="goal.period === 2 ? 'quarter' : 'month'">{{ goal.period === 2 ? '季度' : (goal.month + '月') }}</div>
            <div class="goal-name">{{ goal.saleStar + '星医生' + goal.targetNumber + '名' }}</div>
              <div class="goal-value">
                <span class="current">{{ goal.finishTargetNumber }}</span>
                <span class="total">/{{ goal.targetNumber || 0 }}</span>
              </div>
              <div class="goal-status">
                <span v-if="goal.month && goal.month > new Date().getMonth() + 1" class="status-undo">
                  未开始
                </span>
                <span v-else-if="goal.completeStatus === 1" class="status-undo">
                  <i class="el-icon-success"></i>未完成
                </span>
                <span v-if="goal.completeStatus === 2" class="status-done">
                  <i class="el-icon-success"></i>完成
                </span>
                <span v-else-if="goal.completeStatus === 3" class="status-done">
                  <i class="el-icon-success"></i>超额完成
                </span>
              </div>
            </div>
            <div v-if="showStaffList" class="goal-card-body">
              <span v-for="(team, tIdx) in goal.targetGroupInfoList" :key="team.groupName + '-' + tIdx" class="team-progress">
                {{ team.groupName }} {{ team.finishTargetNumber || 0 }}/{{ team.targetNumber || 0 }}
              </span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'YearGoalDetail',
  data() {
    return {
      starInfo: {},
      goalInfoList: [],
      yearGoalList: [],
      quarterGoalList: [
        {
          quarter: 1,
          name: '第一季度',
          goals: []
        },
        {
          quarter: 2,
          name: '第二季度',
          goals: []
        },
        {
          quarter: 3,
          name: '第三季度',
          goals: []
        },
        {
          quarter: 4,
          name: '第四季度',
          goals: []
        }
      ]
    }
  },
  mounted() {
    this.getGoalInfo()
  },
  methods: {
    // 生成目标的唯一 key
    getGoalKey(goal, index) {
      const period = goal.period || 'unknown'
      const month = goal.month || 0
      const quarter = goal.quarter || 0
      const star = goal.saleStar || 0
      const target = goal.targetNumber || 0
      return `${period}-${quarter}-${month}-${star}-${target}-${index}`
    },

    async getGoalInfo() {
      const params = {
        year: new Date().getFullYear(),
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        }
      }
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/all/detail', params, '')
        if (res.code === 200) {
          const data = res.data || {}
          const startFinishMap = data.startFinishMap || {}
          let completeTotal = 0
          let targetTotal = 0
          for (let key in startFinishMap) {
            if (['3', '4', '5'].includes(key)) {
              completeTotal += Number(startFinishMap[key])
            }
          }
          this.starInfo = { completeTotal, ...startFinishMap }
          this.goalInfoList = data.allTargetCompleteList || []
          this.yearGoalList = this.goalInfoList.filter(item => item.period === 1)

          for (let i = 0; i < this.yearGoalList.length; i++) {
            const item = this.yearGoalList[i]
            if (item.targetStartInfoList && item.targetStartInfoList.length > 0) {
              item.targetStartInfoList.forEach(ite => {
                targetTotal += Number(ite.targetNumber)
              })
            }
          }

          this.starInfo.gap = Math.max(0, targetTotal - completeTotal)

          const quarterGoalList = this.goalInfoList.filter(item => item.period === 2)
          const monthGoalList = this.goalInfoList.filter(item => item.period === 3)

          this.quarterGoalList = this.quarterGoalList.map(item => {
            const quarterInfo = quarterGoalList.find(items => items.quarter === item.quarter)
            const monthInfoList = monthGoalList.filter(items => Math.ceil(items.month / 3) === item.quarter)
            
            // 构建目标列表，过滤掉 undefined
            const quarterGoals = quarterInfo ? (quarterInfo.targetStartInfoList || []).map(goal => {
              return {
                month: quarterInfo.month,
                period: quarterInfo.period,
                quarter: quarterInfo.quarter,
                ...goal
              }
            }) : []
            
            const monthGoals = monthInfoList.flatMap(monthInfo => {
              return (monthInfo.targetStartInfoList || []).map(goal => {
                return {
                  month: monthInfo.month,
                  period: monthInfo.period,
                  quarter: monthInfo.quarter,
                  ...goal
                }
              })
            })
            
            // 合并并去重（基于 saleStar + targetNumber）
            const allGoals = [...quarterGoals, ...monthGoals]
            const uniqueGoals = []
            const seenKeys = new Set()
            
            for (let i = 0; i < allGoals.length; i++) {
              const goal = allGoals[i]
              const key = `${goal.period}-${goal.quarter || 0}-${goal.month || 0}-${goal.saleStar}-${goal.targetNumber}`
              if (!seenKeys.has(key)) {
                seenKeys.add(key)
                uniqueGoals.push(goal)
              }
            }
            
            return {
              ...item,
              goals: uniqueGoals
            }
          })
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取年目标数据失败', error)
      }
    }
  },
  props: {
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    },
    showStaffList: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style scoped lang="less">
.year-goal-detail {
  padding: 20px;
  box-sizing: border-box;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1F2329;
  margin-bottom: 16px;

  .title-bar {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #1890FF;
    border-radius: 2px;
  }
}

// 已引进医生统计
.introduce-stats {
  display: flex;
  background-color: #EEF9FF;
  border-radius: 4px;
  padding: 20px 0;
  width: 400px;

  .stat-item {
    width: 90px;
    text-align: center;
    position: relative;

    &.total {
      width: 130px;
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 24px;
        background-color: #D3D3D5;
      }

      .stat-num {
        color: #1890FF;
      }
    }

    .stat-num {
      font-size: 24px;
      font-weight: 600;
      color: #1F2329;
      line-height: 32px;
    }

    .stat-label {
      font-size: 13px;
      color: #667182;
      margin-top: 4px;
    }
  }
}

.introduce-desc {
  font-size: 13px;
  color: #667182;
  margin-top: 12px;
}

// 目标卡片
.goal-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

// 目标卡片
.goal-card {
  padding: 12px 16px;
  box-sizing: border-box;
  width: 400px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  background-color: #F7F8F9;

  &.year-goal-card {
    background-color: #FFF7DF;
    border-color: #F1E4BD;
  }

  .goal-card-header {
    display: flex;
    align-items: center;
    gap: 8px;

    .goal-tag {
      display: inline-block;
      padding: 3px 6px 4px;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 500;
      flex-shrink: 0;

      &.quarter,
      &.month {
        background: linear-gradient( 73deg, #2395FF 0%, #0478E3 100%);
        color: #FFF;
      }

      &.year {
        background: linear-gradient( 73deg, #FFB170 0%, #FF8B40 100%);
        color: #FFF;
      }
    }

    .goal-name {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      color: #1F2329;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .goal-value {
      flex-shrink: 0;
      font-size: 14px;
      font-weight: 600;
      color: #1F2329;
    }

    .goal-status {
      flex-shrink: 0;
      font-size: 13px;

      .status-done {
        color: #1890FF;

        i {
          margin-right: 2px;
        }
      }

      .status-undo {
        color: #9AA0A8;

        i {
          margin-right: 2px;
        }
      }
    }
  }

  .goal-card-body {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;

    .team-progress {
      font-size: 13px;
      color: #667182;
    }
  }
}
</style>